/**
 * ヘッダー: 下スクロールで非表示、上スクロールで表示
 * .header-change 区域と重なる間はロゴ文字を白表示
 */
const HEADER_HIDDEN_CLASS = 'header--hidden';
const HEADER_OVER_CHANGE_CLASS = 'is-over-header-change';
const SCROLL_THRESHOLD = 10;
const TOP_THRESHOLD = 16;

let lastScrollY = window.scrollY ?? 0;
let ticking = false;

function rectsOverlap(rectA, rectB) {
  return (
    rectA.bottom > rectB.top &&
    rectA.top < rectB.bottom &&
    rectA.right > rectB.left &&
    rectA.left < rectB.right
  );
}

function updateHeaderChange(header) {
  if (!header) {
    return;
  }

  var zones = document.querySelectorAll('.header-change');
  if (!zones.length) {
    header.classList.remove(HEADER_OVER_CHANGE_CLASS);
    return;
  }

  var headerRect = header.getBoundingClientRect();
  var overlaps = false;

  zones.forEach(function (zone) {
    if (rectsOverlap(headerRect, zone.getBoundingClientRect())) {
      overlaps = true;
    }
  });

  header.classList.toggle(HEADER_OVER_CHANGE_CLASS, overlaps);
}

function updateHeader() {
  var header = document.querySelector('.header');
  if (!header) {
    return;
  }

  var scrollY = window.scrollY;

  if (scrollY <= TOP_THRESHOLD) {
    header.classList.remove(HEADER_HIDDEN_CLASS);
    lastScrollY = scrollY;
    updateHeaderChange(header);
    ticking = false;
    return;
  }

  var delta = scrollY - lastScrollY;

  if (delta > SCROLL_THRESHOLD) {
    header.classList.add(HEADER_HIDDEN_CLASS);
    lastScrollY = scrollY;
  } else if (delta < -SCROLL_THRESHOLD) {
    header.classList.remove(HEADER_HIDDEN_CLASS);
    lastScrollY = scrollY;
  }

  updateHeaderChange(header);
  ticking = false;
}

function onScroll() {
  if (ticking) {
    return;
  }
  ticking = true;
  requestAnimationFrame(updateHeader);
}

function refreshHeaderAfterNavigation() {
  lastScrollY = window.scrollY ?? 0;
  ticking = false;
  updateHeader();
  requestAnimationFrame(function () {
    requestAnimationFrame(updateHeader);
  });
  window.setTimeout(updateHeader, 100);
}

function initHeaderScroll() {
  if (window.__headerScrollBound) {
    refreshHeaderAfterNavigation();
    return;
  }
  window.__headerScrollBound = true;
  lastScrollY = window.scrollY ?? 0;
  updateHeader();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeaderScroll);
} else {
  initHeaderScroll();
}

document.addEventListener('swup:replaced', refreshHeaderAfterNavigation);
